import isEmpty from 'lodash/isEmpty';

const seatmapToObjects = (rootJS) => {
    const rootNode = {
        properties: {
            id: 'root',
        },
    };

    const _seatmapToObjects = (iter, iterJS) => {
        if (!iterJS) {
            return;
        }
        //eslint-disable-next-line
        iterJS.map((obj) => {
            const type = obj.type;
            const id = obj.id;
            /*eslint-disable*/

            switch (type) {
                case 'section':
                case 'row':
                case 'stencil':
                case 'line_stencil':
                case 'tableAndChair':
                case 'static_text':
                case 'general_admission_section':
                case 'venue_stencil':
                    const node = {};
                    const toSet = {};
                    for (let key in obj) {
                        if (key != 'children' && key != 'chairs') {
                            toSet[key] = obj[key];
                        }
                    }
                    node.properties = toSet;
                    _seatmapToObjects(node, obj.children);
                    // Let's grab all the chairs
                    if (obj.chairs) {
                        let chairIds = [];
                        let chairs = undefined;

                        chairs = obj.chairs;

                        const unitCount = chairs.x.length;
                        for (let i = 0; i < unitCount; i++) {
                            chairIds.push(`${id}:${i + 1}`);
                        }

                        chairs.id = chairIds;
                        node.chairs = chairs;
                    }
                    if (!iter.contents) {
                        iter.contents = {};
                    }
                    iter.contents[id] = node;
                    break;
                default:
                    break;
            }
            /*eslint-enable*/
            return undefined;
        });
    };

    const t1 = Date.now();

    _seatmapToObjects(rootNode, rootJS);
    const t2 = Date.now();

    console.log('setmap to objects time: ', t2 - t1);
    return rootNode;
};

const parseSeatmap = ({ seatmap }) => {
    if (!seatmap) {
        return {};
    }

    const t2 = new Date();
    const seatmapJS = seatmap.venuemap;
    const seatmapObjects = seatmapToObjects(seatmapJS);
    const t3 = new Date();

    console.log('Object parsing time: ', t3 - t2);
    const rootNode = {
        objects: seatmapObjects,
    };

    const t4 = new Date();

    console.log('Model replace for seatmap time: ', t4 - t3);

    return rootNode;
};

const _parseSingleStatus = ({ singleStatus = {} }) => {
    const { units = {}, groups = {}, data } = singleStatus;

    if (data) {
        return data;
    }

    const result = {};

    Object.keys(units).forEach((key) => {
        const str = units[key] || '';
        const ar = str.split('');

        for (let i = 0; i < ar.length; i++) {
            if (ar[i] === '-') {
                ar[i] = '';
            }
        }
        result[key] = {
            s: ar,
        };
    });
    Object.keys(groups).forEach((key) => {
        const record = groups[key];

        result[key] = {
            S: record,
        };
    });
    return result;
};

// overwrites left with data on right
const _mergeStatus = ({ left, right }) => {
    const newStatus = {
        ...left,
    };

    Object.keys(right).forEach((key) => {
        const rightRecord = right[key];
        let newLeftRecord;

        if (rightRecord.s) {
            const leftRecord = left[key] || {};

            newLeftRecord = {
                ...leftRecord,
            };

            rightRecord.s.forEach((state, index) => {
                if (state) {
                    newLeftRecord.s[index] = state;
                }
            });
            newStatus[key] = newLeftRecord;
        } else if (rightRecord.S) {
            const parts = key.split('-');
            const sectionId = parts[0];

            const leftRecord = left[sectionId] || {};

            newLeftRecord = {
                ...leftRecord,
            };

            const { S, T } = rightRecord;

            newLeftRecord.T = T;
            newLeftRecord.S = S;

            if (parts.length > 1) {
                newLeftRecord.alias = key;
            }

            newStatus[sectionId] = newLeftRecord;
        }
    });
    return newStatus;
};

const parseStatus = ({ mapStatus, holdStatus }) => {
    let mapStatusModel = _parseSingleStatus({ singleStatus: mapStatus });
    if (holdStatus) {
        const holdStatusModel = _parseSingleStatus({
            singleStatus: holdStatus,
        });

        mapStatusModel = _mergeStatus({
            left: mapStatusModel,
            right: holdStatusModel,
        });
    }
    return mapStatusModel;
};

const parseTierColors = ({ tierColors = {} }) => {
    const tiers = {};

    Object.keys(tierColors).forEach((key) => {
        const color = tierColors[key];

        tiers[key] = {
            color,
        };
    });

    return tiers;
};

const parseTiersInfo = ({ tiersInfo = [] }) => {
    const tiers = {};

    tiersInfo.forEach((tierInfo) => {
        tiers[tierInfo.tier] = {
            color: tierInfo.color,
            name: tierInfo.name,
            quantityAvailable:
                tierInfo['quantity_total'] -
                tierInfo['quantity_sold'] -
                tierInfo['quantity_pending'],
            quantityTotal: tierInfo['quantity_total'],
        };
    });

    return tiers;
};

const _parseHoldsFromGroupsRecursive = (groups, holds, status) => {
    const { ids, info } = holds;
    for (let i = 0; i < groups.length; i++) {
        const item = groups[i];

        if (item.groups) {
            _parseHoldsFromGroupsRecursive(item.groups, holds, status);
        }
        if (item.units) {
            for (let i = 0; i < item.units.length; i++) {
                const unit = item.units[i];
                const { hold_id: holdId, id } = unit;

                if (holdId) {
                    if (!info[holdId]) {
                        info[holdId] = {};
                    }
                    ids[id] = holdId;
                }
            }
            // NOTE: Holds applied to a GA section don't have units set.
        } else if (item['hold_id']) {
            const {
                hold_id: holdId,
                id: sectionId,
                quantity: totalHeldQuantity,
            } = item;

            if (!info[holdId]) {
                info[holdId] = {};
            }
            if (isEmpty(info[holdId]) || !info[holdId][sectionId]) {
                info[holdId][sectionId] = {
                    totalHeldQuantity,
                    soldHeldQuantity: status.groups[sectionId].R || 0,
                };
            }
            ids[sectionId] = holdId;
        }
    }
};

const parseHoldsFromGroups = ({ groups = [], status }) => {
    const holds = {
        ids: {},
        info: {},
    };

    _parseHoldsFromGroupsRecursive(groups, holds, status);
    return holds;
};

const seatmapParser = {
    parseHoldsFromGroups,
    parseSeatmap,
    parseStatus,
    parseTierColors,
    parseTiersInfo,
};

export default seatmapParser;
